import { createSlice } from '@reduxjs/toolkit';
export const DetailsPageStatusCardSlice = createSlice({
  name: 'DetailsPageStatusCardSlice',
  initialState: {
    statusData: []
  },
  reducers: {
    pushDetailsPageStatusCardData: (state, action) => {
      const resultObject = action.payload;
      let statusArray = [];

      let backgroundColorCheck = riskName => {
        if (riskName === 'Very High') {
          return ['#FFB41E'];
        } else if (riskName === 'High') {
          return ['#4966F1'];
        } else if (riskName === 'Medium') {
          return ['#571EB3'];
        } else if (riskName === 'Low') {
          return ['#14AD65'];
        }
      };

      statusArray.push({
        title: 'Overall',
        overallRiskScore: resultObject['overallRiskScore'],
        overallRiskCategory: resultObject['overallRiskCategory'],
        backgroundColor: backgroundColorCheck(resultObject.overallRiskCategory)
      });
      statusArray.push({
        header: 'Application',
        title: resultObject.origin,
        originRiskCategory: resultObject['originRiskCategory'],
        originRiskScore: resultObject['originRiskScore'],
        backgroundColor: backgroundColorCheck(resultObject.originRiskCategory)
      });
      statusArray.push({
        header: 'Environment',
        title: resultObject.envName,
        originRiskCategory: resultObject['accountRiskCategory'],
        originRiskScore: resultObject['accountRiskScore'],
        backgroundColor: backgroundColorCheck(resultObject.accountRiskCategory)
      });
      state.statusData = statusArray;
    }
  }
});
export const {
  pushDetailsPageStatusCardData
} = DetailsPageStatusCardSlice.actions;
export default DetailsPageStatusCardSlice.reducer;